import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { experiments } from '../../services/payex/experiments/experiments';

type TrackEventParams = {
  eventName: string;
  eventProperties?: Record<string, string | boolean | number>;
  userId?: string;
};

type TrackEventResponse = void;

export const useExperimentTrack = (
  opts: UseMutationOptions<TrackEventResponse, unknown, TrackEventParams> = {},
): ((params: TrackEventParams) => void) => {
  const { mutate } = useMutation<TrackEventResponse, unknown, TrackEventParams>(
    (params: TrackEventParams) => {
      return experiments.trackEvent(
        params.eventName,
        params.eventProperties,
        params.userId,
      );
    },
    opts,
  );

  return (params: TrackEventParams) => mutate(params);
};
